import { Video, AlertCircle } from "lucide-react";
import { useUploads } from "@/lib/uploadManager";
import { useTick, liveStatus } from "@/components/video/VideoUploader";

// Compact, always-visible upload status while the seller moves between steps. Tap to jump to the videos.
export function UploadIndicator({ scopeId, onOpen }) {
  const list = useUploads(scopeId);
  useTick(list.length > 0);
  if (!list.length) return null;
  const st = list.map(liveStatus);
  const up = list.filter((_, i) => ["uploading", "waiting", "stalled"].includes(st[i]));
  const failed = st.filter((s) => s === "failed").length;
  const pct = up.length ? Math.round(up.reduce((a, x) => a + (x.progress || 0), 0) / up.length) : 0;
  const stalled = st.includes("stalled");
  const text = up.length
    ? `${up.length} video${up.length > 1 ? "s" : ""} uploading — ${pct}%${stalled ? " · stalled, check connection" : ""}`
    : `${failed} video upload${failed > 1 ? "s" : ""} failed — tap to retry`;
  const bad = stalled || (!up.length && failed);
  return (
    <button type="button" data-testid="upload-indicator" onClick={onOpen} aria-live="polite"
      className={`w-full min-h-[40px] px-3 py-2 flex items-center gap-2 text-left text-sm font-semibold ${bad ? "bg-orange-50 text-orange-900" : "bg-sky-50 text-sky-900"}`}>
      {bad ? <AlertCircle className="h-4 w-4 shrink-0" /> : <Video className="h-4 w-4 shrink-0" />}
      <span className="flex-1 truncate">{text}</span>
      {up.length > 0 && <span className="h-1.5 w-16 rounded bg-white/70 overflow-hidden shrink-0"><span className="block h-full bg-sky-600" style={{ width: `${pct}%` }} /></span>}
    </button>
  );
}
